import { createContext } from 'react';
import type { EagerImages } from '@xshop/shared';

// The page's eager pictures as each picture reads them while it draws; which ones they are is the shared rule
// (leadImage.ts in @xshop/shared), so the server preloading the hero picks the same one.

/** Nothing loaded at once: the answer outside a page, and while a tree is empty. */
export const NO_EAGER_IMAGES: EagerImages = { eager: new Set(), lead: null };

/** The page's eager pictures, read by each picture as it draws. */
export const EagerImagesContext = createContext<EagerImages>(NO_EAGER_IMAGES);
